import { render, staticRenderFns } from "./CoozzyFormInput.vue?vue&type=template&id=86d452a8&scoped=true"
import script from "./CoozzyFormInput.vue?vue&type=script&lang=js"
export * from "./CoozzyFormInput.vue?vue&type=script&lang=js"
import style0 from "./CoozzyFormInput.vue?vue&type=style&index=0&id=86d452a8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86d452a8",
  null
  
)

export default component.exports